'use strict';

exports.__esModule = true;

var _class, _temp; // import Grid from "../../../ui/Grid"
// import {
//   Pagination,
//   Link,
// } from "../../../ui"


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _materialUi = require('material-ui');

var _List = require('./List');

var _List2 = _interopRequireDefault(_List);

var _context2 = require('@prisma-cms/context');

var _context3 = _interopRequireDefault(_context2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var ProjectsView = (_temp = _class = function (_Component) {
  _inherits(ProjectsView, _Component);

  function ProjectsView() {
    _classCallCheck(this, ProjectsView);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  ProjectsView.prototype.render = function render() {
    var _context = this.context,
        Pagination = _context.Pagination,
        Link = _context.Link,
        Grid = _context.Grid;
    var page = this.props.page;
    var _props$data = this.props.data,
        objectsConnection = _props$data.objectsConnection,
        loading = _props$data.loading,
        limit = _props$data.variables.first;

    var _ref = objectsConnection || {},
        edges = _ref.edges,
        aggregate = _ref.aggregate;

    var _ref2 = aggregate || {},
        _ref2$count = _ref2.count,
        count = _ref2$count === undefined ? 0 : _ref2$count;

    var output = void 0;

    if (!edges || !edges.length) {
      if (loading) {
        output = null;
      } else {
        output = _react2.default.createElement(_materialUi.Typography, {
          variant: 'title'
        }, "\u0414\u0430\u043D\u043D\u044B\u0435 \u043D\u0435 \u0431\u044B\u043B\u0438 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u044B");
      }
    } else {
      var projects = edges.map(function (n) {
        return n.node;
      });
      output = _react2.default.createElement(Grid, {
        item: true,
        xs: 12
      }, _react2.default.createElement(_List2.default, {
        projects: projects
      }), _react2.default.createElement(Pagination, {
        limit: limit,
        total: count,
        page: page || 1,
        style: {
          marginTop: 20
        }
      }));
    }

    var content = _react2.default.createElement(Grid, {
      container: true,
      spacing: 0
    }, _react2.default.createElement(Grid, {
      item: true,
      xs: 12
    }, _react2.default.createElement(Link, {
      to: '/projects/create'
    }, _react2.default.createElement(_materialUi.Typography, null, "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043F\u0440\u043E\u0435\u043A\u0442"))), output);

    return content;
  };

  return ProjectsView;
}(_react.Component), _class.contextType = _context3.default, _temp);
exports.default = ProjectsView;
module.exports = exports['default'];